import React from 'react';
import background from '../../assets/natural-threats_bg.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';

class InfoNaturalthreats extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="ATMOSPHERE"
        description="Natural Threats"
        paragraph=""
        coverbackground={background}
     />
  
  );
 }
}   

export default InfoNaturalthreats;